import { default as authToken } from '~/src/shared/lib/auth_token.js';

/**
 * @param {Object} options
 * {
 *   endpoint: <String>,
 *   search_string: <String>,
 *   district_search: <String>,
 *   one_roster_search: <String>,
 *   exclude_internal_schools: <String>,
 *   selected_market: <String>,
 * }
 */
export default async function searchSchools(options) {
  const url = `${location.origin}/${options.endpoint}`;
  const payload = {
    search_string: options.search_string,
    district_search: options.district_search,
    one_roster_search: options.one_roster_search,
    exclude_internal_schools: options.exclude_internal_schools,
    selected_market: options.selected_market,
  }
  const data = {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
      'X-CSRF-Token': authToken,
    }
  };
  const response = await fetch(url, data);
  const parsedResponse = await response.json();
  return parsedResponse;
}
